/* eslint-disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".editingInput_b2916c76{border:0;outline:0}.editingInput_b2916c76::-ms-clear{display:none}.editingContainer_b2916c76{margin:4px}"}]);
export const editingInput = "editingInput_b2916c76";
export const editingContainer = "editingContainer_b2916c76";